import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import { takeEvery, put } from 'redux-saga/effects';
import {CREATE_PAYMENT_ITEM_REQEUSTED, CREATE_PAYMENT_ITEM_SUCCEEDED, FETCH_PAYMENT_DETAIL_REQUESTED, FETCH_PAYMENT_DETAIL_SUCCEEDED} from "./pay.actions";
import {REMOVE_CHANGED_ITEM} from "../list/list.actions";

function* doPaymentRequest(action) {
  const api = AppInjector.get(ApiService);
  try {
    if (!Array.isArray(action.data)) {
      let result = yield api.payment.pay(action.id, action.data).toPromise();
      yield put({ type: CREATE_PAYMENT_ITEM_SUCCEEDED, data: result, next: action.next, nextParams: action.nextParams });
    } else {
      let result = yield api.payment.payInBulk(action.data).toPromise();
      yield put({ type: CREATE_PAYMENT_ITEM_SUCCEEDED, data: result, next: action.next, nextParams: action.nextParams });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDoPaymentRequest() {
  yield takeEvery(CREATE_PAYMENT_ITEM_REQEUSTED, doPaymentRequest);
}

function* doPaymentSuccess(action) {
  const router = AppInjector.get(Router);
  router.navigate([action.next], {queryParams: {untouched: true, ...(action.nextParams ? action.nextParams : {})}});
  yield put({ type: REMOVE_CHANGED_ITEM, data: action.data.getContent ? action.data.getContent().map(s => s.id) : [parseInt(action.data.id)]});
}

function* watchDoPaymentSuccess() {
  yield takeEvery(CREATE_PAYMENT_ITEM_SUCCEEDED, doPaymentSuccess);
}

function* getDetailRequest(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.payment.getItemById(action.id).toPromise();
    yield put({ type: FETCH_PAYMENT_DETAIL_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetDetailRequest() {
  yield takeEvery(FETCH_PAYMENT_DETAIL_REQUESTED, getDetailRequest);
}


export default [watchDoPaymentRequest, watchDoPaymentSuccess, watchGetDetailRequest];
